const { InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const {
    imageOption,
    image,
    image2,
    contentPos,
    imgPosVertical,
    margin,
    background,
    maxWidth,
  } = attributes;

  return (
    <section className={`Hero ${margin} ${background} ${imageOption}`}>
      <div className={`Hero__wrapper Container Hero__wrapper-${contentPos}`}>
        <div className={`Hero--content ${maxWidth}`}>
          <InnerBlocks.Content />
        </div>

        <div
          className={`Hero--imageWrapper Hero--imageWrapper-${imgPosVertical} Hero--imageWrapper-${contentPos}`}
        >
          <img title={image.alt} src={image.src} alt={image.alt} />
          {imageOption == 'twoImages' && (
            <img title={image2.alt} src={image2.src} alt={image2.alt} />
          )}
        </div>
      </div>
    </section>
  );
};
